export const getAllTags = (text) => {
    return new Promise((resolve) => {
        
        let body = {
            searchTerm: text,
            guildId: 0
        };
        
        fetch('/tagSearch/' , {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp);
            });
    });
};
